/* eslint-disable */
var StringFormat = require('string-format');
import isNaN from 'lodash/isNaN';

export const REQUIRED = 'This field is required';
export const INVALID_EMAIL = 'Invalid email';
export const INVALID_NUMBER = 'Invalid number';
export const INVALID_DECIMAL_POSITIVE_NUMBER =
  'This field is a positive number have {0} digits and maximum of {1} decimal';
export const MAXIMUM1 = '{0} is maximum {1} characters';
export const MAXIMUM2 = 'Maximum {0} character';
export const MINIMUM1 = '{0} is minimum {1} characters';
export const MINIMUM2 = 'Minimum {0} character';
export const MINIMUM1PASS = '{0} must be at least {1} characters';
export const MINIMUM2PASS = 'Must be at least {0} characters';
export const INVALID_PASSWORD_ALPHANUMERIC = 'Password must contain at least one letter or number';
export const INVALID_PASSWORD_SPECIAL_CHAR = 'Password must contain at least one special character (@, #, $, %, &)';

export const required = (value = '', props) => {
  if (props.type === 'password') {
    if (!value.toString().length) {
      if (props.placeholder) {
        return REQUIRED;
      }
      return REQUIRED;
    }
  } else if (!value.toString().trim().length) {
    if (props.placeholder) {
      return REQUIRED;
    }
    return REQUIRED;
  }
  return '';
};

export const email = (value, props, components) => {
  //http://jsfiddle.net/ghvj4gy9/embedded/result,js/
  const emailString = value; // ? value.toString().replace(/ +/g, "") : '';

  var emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,8}$/;

  if (!emailPattern.test(emailString)) {
    if (!props) {
      return;
    }
    if (props.errorMsg) {
      return props.errorMsg;
    }
    if (props.placeholder) {
      return INVALID_EMAIL;
    }

    return INVALID_EMAIL;
  }

  setTimeout(email, 50);
};

export const emailvali = (value, props = {}) => {
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  if (!emailPattern.test(value)) {
    return props.errorMsg || "Please enter a valid email address.";
  }

  return null; 
};

export const validatePasswordContent = (value, props) => {
  value = value === null ? '' : value.toString();

  // Skip check if field is not password
  if (props.type !== 'password') return '';

  // Alphanumeric check (A-Z, a-z, 0-9)
  const hasAlphanumeric = /[A-Za-z0-9]/.test(value);
  if (!hasAlphanumeric) {
    return INVALID_PASSWORD_ALPHANUMERIC;
  }

  // Special character check (@, #, $, %, &)
  const hasSpecialChar = /[@#$%&]/.test(value);
  if (!hasSpecialChar) {
    return INVALID_PASSWORD_SPECIAL_CHAR;
  }

  return '';
};

export const maxlength = (value, props) => {
  value = value === null ? '' : value;
  if (props.type === 'password') {
    if (value.toString().length > Number(props.max)) {
      if (props.errorMsg) {
        return props.errorMsg;
      }
      if (props.placeholder) {
        return StringFormat(MAXIMUM1, props.placeholder, props.max);
      }
      return StringFormat(MAXIMUM2, props.max);
    }
  } else if (value.trim().length > Number(props.max)) {
    if (props.errorMsg) {
      return props.errorMsg;
    }
    if (props.placeholder) {
      return StringFormat(MAXIMUM1, props.placeholder, props.max);
    }
    return StringFormat(MAXIMUM2, props.max);
  }
};

export const phoneOptional = (value = '', props) => {
  const trimmedValue = value.trim();
  if (!trimmedValue) return ''; // Optional, so blank is okay

  const pattern = /^[0-9()+\-\s]{6,15}$/;
  if (!pattern.test(trimmedValue)) {
    return 'Invalid phone number format';
  }

  return '';
};

export const passwordStrength = (value, props) => {
  value = value || '';

  const hasUpperCase = /[A-Z]/.test(value);
  const hasLowerCase = /[a-z]/.test(value);
  const hasNumber = /[0-9]/.test(value);
  const hasSpecialChar = /[@#$%&]/.test(value); // you can expand this if needed

  if (!hasUpperCase || !hasLowerCase || !hasNumber || !hasSpecialChar) {
    return 'Password must include at least one uppercase letter, one lowercase letter, one number, and one special character (@, #, $, %, &).';
  }

  return '';
};

export const minlength = (value, props) => {
  value = value === null ? '' : value;
  if (props.type === 'password') {
    if (value.toString().length < Number(props.min)) {
      if (props.errorMsg) {
        return props.errorMsg;
      }
      if (props.placeholder) {
        return StringFormat(MINIMUM2, props.placeholder, props.max);
      }
      return StringFormat(MINIMUM2, props.max);
    }
  } else if (value.trim().length < Number(props.min)) {
    if (props.errorMsg) {
      return props.errorMsg;
    }
    if (props.placeholder) {
      return StringFormat(MINIMUM1, props.placeholder, props.min);
    }
    return StringFormat(MINIMUM2, props.min);
  }
};

export const minlengthPass = (value, props) => {
  value = value === null ? '' : value;
  const min = Number(props.min);
  const label = props.label || props.name || 'Password';

  if (props.type === 'password') {
    if (value.toString().length < min) {
      if (props.errorMsg) {
        return props.errorMsg;
      }
      return StringFormat(MINIMUM1PASS, label, min);
    }
  } else if (value.trim().length < min) {
    if (props.errorMsg) {
      return props.errorMsg;
    }
    return StringFormat(MINIMUM1PASS, label, min);
  }
};

export const compare = (value, props, components) => {
  var refComponents = components[props.compare][0];
  if (props.compareType === 'smaller') {
    if (parseFloat(value) < parseFloat(refComponents.value)) {
      if (props.compareErrorMsg.length) {
        return props.compareErrorMsg;
      }
      return props.errorMsg;
    }
  } else if (props.compareType === 'bigger') {
    if (parseFloat(value) > parseFloat(refComponents.value)) {
      if (props.compareErrorMsg) {
        return props.compareErrorMsg;
      }
      return props.errorMsg;
    }
  } else if (value !== refComponents.value) {
    return props.errorMsg;
  }
};

export const isNumber = (value, props, components) => {
  // Number and decimal checking.
  if (value) {
    const re = new RegExp(/^\d*\.?\d*$/);
    if (re.test(value)) {
      //  this.setState({value: e.target.value})
    } else {
      return StringFormat(INVALID_NUMBER);
    }
  } else {
    return REQUIRED;
  }
  // Old code
  // if(isNaN(parseFloat(amount)) || parseFloat(value).toString() !== value.toString()) {
  //   return StringFormat(INVALID_NUMBER);
  // }
};

export const isFloatTwoDecimal = (value, props, components) => {
  if (/^\d*(\.\d{0,2})?$/.test(value)) {
    // if(isNaN(parseFloat(value)) || parseFloat(value).toString() !== value.toString()) {
    //   return StringFormat(INVALID_NUMBER);
    // }
  } else {
    if (value === null) {
      return;
    }
    return StringFormat(INVALID_NUMBER);
  }
};

export const isPositiveFloatDecimal = (value, props, components) => {
  const DECIMAL_POSITIVE_NUMBER_REGEX = new RegExp(
    '^0*\\d{0,' +
      (props.maxDigit || 17) +
      '}(\\.\\d{0,' +
      (props.maxDecimalDigit || 2) +
      '}0*)?$',
    'i'
  );

  if (!DECIMAL_POSITIVE_NUMBER_REGEX.test(value)) {
    return StringFormat(
      INVALID_DECIMAL_POSITIVE_NUMBER,
      props.maxDigit,
      props.maxDecimalDigit
    );
  }

  return;
};



// WEBPACK FOOTER //
// ./src/helper/validator-helper.js